import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Question.css"; // Import CSS for styling

const QQuadraticEquation = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("numerical"); // Default: Numerical Tab

  const numericalQuestions = [
    {
      question: (<>Ques(1). Find the number of subsets of the set {"{"}1,2,3,4{"}"}. <span className="exam-year">[UPSEE(2003)]</span></>), 
      answer: "16",
    },
    {
      question: (<>Ques(2). If A = {"{"}1,2,3{"}"} and B = {"{"}2,3,4{"}"}, find |A ∪ B|. <span className="exam-year">[IIT-JEE Adv.(2000)]</span></>),
      answer: "4",
    }
  ];

  const mcqQuestions = [
    {
      question: (<>Ques(1). Which of the following is a null set? <span className="exam-year">[IIT-JEE Mains (2025)]</span></>),
      options: ["{0}", "{}", "{∅}", "{1,2,3}"],
      answer: "{}",
    },
    {
      question: (<>Ques(2). What is the power set of {"{"}a, b{"}"}? <span className="exam-year">[IIT-JEE Adv. (2021)]</span></>),
      options: ["{∅, a, b, {a,b}}", "{a, b, {a,b}}", "{a, b}", "{∅, a}"],
      answer: "{∅, a, b, {a,b}}",
    }
  ];

  const [showAnswer, setShowAnswer] = useState(Array(numericalQuestions.length).fill(false));
  const [selectedAnswers, setSelectedAnswers] = useState(Array(mcqQuestions.length).fill(null));

  // Toggle answer visibility for numerical questions
  const toggleAnswer = (index) => {
    const updatedAnswers = [...showAnswer];
    updatedAnswers[index] = !updatedAnswers[index];
    setShowAnswer(updatedAnswers);
  };

  // Handle MCQ option selection
  const handleOptionSelect = (qIndex, option) => {
    const updatedSelectedAnswers = [...selectedAnswers];
    updatedSelectedAnswers[qIndex] = option;
    setSelectedAnswers(updatedSelectedAnswers);
  };

  return (
    <div className="question-page">
      <h1 className="question-heading">Quadratic Equation - Previous Year Questions</h1>

      {/* Toggle Buttons for Mobile View */}
      <div className="tab-container">
        <button className={`tab-btn ${activeTab === "numerical" ? "active" : ""}`} onClick={() => setActiveTab("numerical")}>
          Numerical Questions
        </button>
        <button className={`tab-btn ${activeTab === "mcq" ? "active" : ""}`} onClick={() => setActiveTab("mcq")}>
          MCQ Questions
        </button>
      </div>

      {/* Question Sections */}
      <div className="question-container">
        {/* Numerical Section (Visible when tab is "numerical") */}
        <div className={`question-section ${activeTab === "numerical" ? "visible" : "hidden"}`}>
          <h2 className="section-title">Numerical-Based Questions</h2>
          <div className="scrollable-content">
            {numericalQuestions.map((item, index) => (
              <div key={index} className="question-item">
                <p>{item.question}</p>
                <button className="answer-btn" onClick={() => toggleAnswer(index)}>
                  {showAnswer[index] ? "Hide Answer" : "View Answer"}
                </button>
                {showAnswer[index] && <p className="answer-text">{item.answer}</p>}
              </div>
            ))}
          </div>
        </div>

        {/* MCQ Section (Visible when tab is "mcq") */}
        <div className={`question-section ${activeTab === "mcq" ? "visible" : "hidden"}`}>
          <h2 className="section-title">MCQ-Based Questions</h2>
          <div className="scrollable-content">
            {mcqQuestions.map((item, qIndex) => (
              <div key={qIndex} className="question-item">
                <p>{item.question}</p>
                <ul className="options-list">
                  {item.options.map((option, optIndex) => (
                    <li
                      key={optIndex}
                      className={`option ${
                        selectedAnswers[qIndex] !== null
                          ? option === item.answer
                            ? "correct"
                            : selectedAnswers[qIndex] === option
                            ? "incorrect"
                            : ""
                          : ""
                      }`}
                      onClick={() => handleOptionSelect(qIndex, option)}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button className="back-home-btn" onClick={() => navigate(-1)}>⬅ Back to PYQs</button>
    </div>
  );
};

export default QQuadraticEquation;
